import * as types from "./types";

// get all stories//
const fetchRequest = () => ({
   type: types.FETCH_REQUEST,
});

const fetchRequestCompleted = (data, fetchByFilter) => ({
   type: types.FETCH_DETAILS_COMPLETED,
   payload: {
      storiesData: data,
      fetchByFilter,
   },
});

const fetchRequestFailed = error => ({
   type: types.FETCH_DETAILS_FAILED,
   payload: {
      error,
   },
});

// get all stories by filter//
const filterStories = () => ({
   type: types.FILTER_STORIES_REQUEST,
});

const filterStoriesCompleted = data => ({
   type: types.FILTER_STORIES_COMPLETED,
   payload: {
      storiesData: data,
   },
});

const filterStoriesFailed = error => ({
   type: types.FILTER_STORIES_FAILED,
   payload: {
      error,
   },
});

// get nex page /
const newFetchRequest = () => ({
   type: types.NEW_FETCH_REQUEST,
});

const newFetchRequestCompleted = data => ({
   type: types.NEW_FETCH_DETAILS_COMPLETED,
   payload: {
      storiesData: data,
   },
});

const newFetchRequestFailed = error => ({
   type: types.NEW_FETCH_DETAILS_FAILED,
   payload: {
      error,
   },
});

// get statistics //
const statisticsRequest = () => ({
   type: types.FETCH_STATISTICS_REQUEST,
});

const statisticsRequestCompleted = data => ({
   type: types.FETCH_STATISTICS_COMPLETED,
   payload: data,
});

const statisticsRequestFailed = error => ({
   type: types.FETCH_STATISTICS_FAILED,
   payload: {
      error,
   },
});

// share store

const fetchUploadImage = data => ({
   type: types.FETCH_UPLOAD_IMG_COMPLETED,
   payload: data,
})

const shareNewPostRequest = () => ({
   type: types.SHANRE_NEW_POST_REQUEST,
});

const shareNewPostCompleted = data => ({
   type: types.SHANRE_NEW_POST_COMPLETED,
   payload: data,
});

const shareNewPostFailed = error => ({
   type: types.SHANRE_NEW_POST_FAILED,
   payload: {
      error,
   },
});
const updatePostRequest = () => ({
   type: types.UPDATE_POST_REQUEST,
});

const updatePostCompleted = data => ({
   type: types.UPDATE_POST_COMPLETED,
   payload: data,
});
const updateVideoCompleted = data => ({
   type: types.UPDATE_VIDEO_COMPLETED,
   payload: data,
});

const updatePostFailed = error => ({
   type: types.UPDATE_POST_FAILED,
   payload: {
      error,
   },
});

// delete story
const deleteStoryRequest = () => ({
   type: types.DELETE_STORY_REQUEST,
});

const deleteStoryCompleted = data => ({
   type: types.DELETE_STORY_COMPLETED,
   payload: data,
});

const deleteStoryFailed = error => ({
   type: types.DELETE_STORY_FAILED,
   payload: {
      error,
   },
});
// delete img
const deleteImageRequest = () => ({
   type: types.DELETE_IMG_REQUEST,
});

const deleteImageCompleted = data => ({
   type: types.DELETE_IMG_COMPLETED,
   payload: data,
});

const deleteImageFailed = error => ({
   type: types.DELETE_IMG_FAILED,
   payload: {
      error,
   },
});

// GET STORY BY ID

const getByIdRequest = () => ({
   type: types.GET_BY_ID_REQUEST,
});

const getByIdCompleted = data => ({
   type: types.GET_BY_ID_COMPLETED,
   payload: data,
});

const getByIdFailed = error => ({
   type: types.GET_BY_ID_FAILED,
   payload: {
      error,
   },
});


/////////////////////////////////////////////
const fetchEditedStoryRequest = () => ({
   type: types.FETCH_EDITED_STORY_REQUEST,
});

const fetchEditedStoryCompleted = data => ({
   type: types.FETCH_EDITED_STORY_COMPLETED,
   payload: {
      editedStory: data,
   },
});

const setEditedStoryInput = (key, value) => ({
   type: types.SET_EDITED_STORY_INPUT,
   payload: {
      key,
      value,
   },
});

// upload poster image
const uploadPosterImageStart = () => ({
   type: types.UPLOAD_POSTER_START,
});

const uploadPosterImageCompleted = data => ({
   type: types.UPLOAD_POSTER_COMPLETED,
   payload: data,
});

const uploadPosterImageFailed = (data) => ({
   type: types.UPLOAD_POSTER_FAILED,
   payload: data,
});
const pinStoryCompleted = (data) => ({
   type: types.PIN_STORY_COMPLETED,
   payload: data,
});

//reorder
const reorderStories = (data) => ({
   type: types.REORDER_STORIES,
   payload: data,
})

const updateStoryCompleted = (id, updatedData) => ({
   type: types.UPDATE_STORY_COMPLETED,
   payload: { id, updatedData },
})

export {
   fetchRequest,
   fetchRequestCompleted,
   fetchRequestFailed,
   newFetchRequest,
   newFetchRequestCompleted,
   newFetchRequestFailed,
   statisticsRequest,
   statisticsRequestCompleted,
   statisticsRequestFailed,
   fetchEditedStoryRequest,
   fetchEditedStoryCompleted,
   setEditedStoryInput,
   //by filter
   filterStories,
   filterStoriesCompleted,
   filterStoriesFailed,

   // share
   fetchUploadImage,
   shareNewPostRequest,
   shareNewPostCompleted,
   shareNewPostFailed,
   updatePostRequest,
   updatePostCompleted,
   updatePostFailed,
   updateVideoCompleted,

   // delete story
   deleteStoryRequest,
   deleteStoryCompleted,
   deleteStoryFailed,

   // get by id
   getByIdRequest,
   getByIdCompleted,
   getByIdFailed,

   // delete image
   deleteImageRequest,
   deleteImageCompleted,
   deleteImageFailed,

   uploadPosterImageStart,
   uploadPosterImageCompleted,
   uploadPosterImageFailed,
   pinStoryCompleted,

   //reorder
   reorderStories,
   updateStoryCompleted,
};
